import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import classnames from 'classnames';
import { Progress } from 'antd';
import { commafy } from 'helpers/number';
import { useConfig } from 'hook/config.hook';
import OText from 'components/CText/OText';

const AccountTradeLines = ({ tradelines }) =>
  tradelines?.map(tradeline => (
    <div className="margb16" key={tradeline.tradeLineName.split(' ').join()}>
      <Label className="Body-2 toUpper margb8">{tradeline.tradeLineName}</Label>
      <FlexContainer className="margb2" justifyBetween>
        <Label type="caption" className="bold">
          ${commafy(tradeline.currentUsageDollarAmount)} of $
          {commafy(tradeline.currentCreditLimit)} limit
        </Label>
        <Label type="Body-2">{tradeline.currentUsagePercentage}%</Label>
      </FlexContainer>
      <Progress
        percent={tradeline.currentUsagePercentage}
        showInfo={false}
        strokeColor="#f9a257"
        aria-label="progressBar"
      />
    </div>
  ));

const StepsSnowBallManagement = ({ config }) => {
  const steps = config?.notificationAlerts?.changeInCreditCardBalance?.steps;
  return (
    <>
      {steps.map(step => (
        <FlexContainer
          className="column-gap-16"
          key={step.step.split('').join('-')}
        >
          <div className="position-relative padt8">
            <div className="stepsCheckMarkCss" />
          </div>
          <div>
            <Label type="subTitle2" className={'margT8 bold'}>
              {step.step}
            </Label>
            <OText className="margT2" text={step.description} />
          </div>
        </FlexContainer>
      ))}
    </>
  );
};

const AccountHighBalanceNotification = props => {
  const { config } = useConfig();
  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader={'h4'}>
          Change in Card Balance
        </Label>
      </Row>

      <Row>
        <FlexContainer column>
          <Label className="caption fontGray300">
            {`Reported on ${props.alertDetailsConfig?.date} to `}
            {
              props?.bureauLogo[
                props.selectedAlertDetails?.bureau ||
                  props.selectedAlertDetails?.alertProvider
              ]
            }
          </Label>

          <Label className="text-16 bold margt20">
            {config?.notificationAlerts?.changeInCreditCardBalance?.title}
          </Label>
          <Label type="Body1" className="margT16 mBody-2">
            {config?.notificationAlerts?.changeInCreditCardBalance?.content}
          </Label>
          <div className="margt16">
            <Label type="H5" typeHeader={'h5'} className="bold margb16">
              Your current balance
            </Label>
            <AccountTradeLines
              tradelines={props?.selectedAlertDetails?.alertDetails?.tradelines}
            />
          </div>
        </FlexContainer>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row>
        <Label className={'H4 margT40 m-margT20'}>
          {config?.notificationAlerts?.changeInCreditCardBalance?.step_title}
        </Label>
        <Label className={'Body-2  margT16'}>
          {config?.notificationAlerts?.changeInCreditCardBalance?.step_subTtile}
        </Label>
        {config?.notificationAlerts?.changeInCreditCardBalance
          ?.step_subTtile_2 && (
          <Label className={'Body-2  margT16'}>
            {
              config?.notificationAlerts?.changeInCreditCardBalance
                ?.step_subTtile_2
            }
          </Label>
        )}
        <FlexContainer className="margT16" column>
          <StepsSnowBallManagement config={config} />
        </FlexContainer>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row className="padt20">
        <FrequentlyAskedQuestions
          frequentlyAskedQuestion={
            config?.notificationAlerts?.changeInCreditCardBalance?.faq
          }
        />
      </Row>
    </SectionContainer>
  );
};

export default AccountHighBalanceNotification;
